import React, { memo, useCallback, useMemo } from 'react';
import { Tooltip, Icon, createUseStyles } from '@Sage/hoi-poi-ui';
import { useWeb5Context } from "../../../../../lib/Web5Context";
import styles from "./styles.js";
const useStyles = createUseStyles(styles, 'ReadOnly');
var _ref2 = /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement(Icon, {
  name: "lock"
}));
const ReadOnly = _ref => {
  let {
    api,
    context,
    data,
    eGridCell,
    node,
    customTooltip
  } = _ref;
  const {
    t
  } = useWeb5Context();
  const classes = useStyles();
  const elementId = useMemo(() => {
    const tableId = (context === null || context === void 0 ? void 0 : context.tableId) || '';
    return tableId ? `w5-actions-component-${tableId}` : 'w5-actions-component';
  }, [context]);
  const actionsWrapper = useMemo(() => document.getElementById(elementId), [elementId]);
  const getBodyViewPort = useCallback(() => {
    var _context$tableRef, _context$tableRef$cur;
    const tableDiv = (context === null || context === void 0 ? void 0 : (_context$tableRef = context.tableRef) === null || _context$tableRef === void 0 ? void 0 : (_context$tableRef$cur = _context$tableRef.current) === null || _context$tableRef$cur === void 0 ? void 0 : _context$tableRef$cur.eGridDiv) || null;
    let bodyViewport = api.gridBodyCtrl.eBodyViewport;
    if (tableDiv) {
      bodyViewport = tableDiv.querySelector('.ag-body-viewport');
    }
    return bodyViewport;
  }, [api.gridBodyCtrl.eBodyViewport, context === null || context === void 0 ? void 0 : context.tableRef]);
  const handleOnMouseEnter = useCallback(() => {
    const bodyViewport = getBodyViewPort();
    const bodyViewportContent = bodyViewport.children;
    let bodyViewportContentChild;
    for (let current of bodyViewportContent) {
      if (current.classList.contains('ag-center-cols-clipper')) {
        bodyViewportContentChild = current;
      }
    }

    // We need to inform about that to add the correct style to prevent overlap the scroll bar.
    const hasScroll = bodyViewportContentChild.offsetHeight > bodyViewport.offsetHeight;
    context.getHoveredRowInfo({
      data: data,
      hasScroll,
      rowElement: eGridCell === null || eGridCell === void 0 ? void 0 : eGridCell.offsetParent
    });
    const scrollTop = bodyViewport.scrollTop;
    actionsWrapper.style.display = 'block';
    const centerElement = 40 - scrollTop;
    const actionsTop = node.rowTop + centerElement;
    actionsWrapper.style.top = `${actionsTop + 3}px`;
    actionsWrapper.style.height = `${node.rowHeight - 2}px`;
  }, [actionsWrapper.style, context, data, eGridCell === null || eGridCell === void 0 ? void 0 : eGridCell.offsetParent, getBodyViewPort, node.rowHeight, node.rowTop]);
  const handleOnMouseLeave = useCallback(() => {
    actionsWrapper.style.display = 'none';
  }, [actionsWrapper.style]);
  const rootProps = useMemo(() => ({
    className: classes.root,
    onMouseEnter: handleOnMouseEnter,
    onMouseLeave: handleOnMouseLeave
  }), [classes.root, handleOnMouseEnter, handleOnMouseLeave]);
  const tooltipProps = useMemo(() => ({
    placement: 'top',
    content: t(customTooltip || 'label_necessary_for_sage')
  }), [customTooltip, t]);
  return /*#__PURE__*/React.createElement("div", rootProps, data !== null && data !== void 0 && data.readOnly ? /*#__PURE__*/React.createElement(Tooltip, tooltipProps, _ref2) : null);
};
export default /*#__PURE__*/memo(ReadOnly);